import clsx from 'clsx';

export interface ICardProps {
    title: string;
    value: string;
    className: string;
}

const Card: React.FC<ICardProps> = ({ title, value, className }) => {
    return (
        <div className={clsx('bg-white rounded-[6px] p-[16px]', className)}>
            <p className="font-normal whitespace-nowrap text-blueGray-500 text-[14px] leading-[21px]">
                {title}
            </p>
            <p className="font-medium text-ellipsis text-blueGray-600 text-[14px] leading-[21px]">
                {value}
            </p>
        </div>
    );
};

export default Card;
